import { render, staticRenderFns } from "./OpcionV.vue?vue&type=template&id=afde54a0"
import script from "./OpcionV.vue?vue&type=script&lang=js"
export * from "./OpcionV.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports